
import api from '@/api/proxyWeb/commandes'

export default {

    getAll({ commit, rootState }) {

        commit('setCommandes', null)

        let params = {
            client_id: rootState.clients.currentId,
            site_id: rootState.sites.currentId
        }

        return new Promise(resolve => {
        
            Promise.all([
                api.count(params),
                api.list(params)
            ])
            .then( ([ count, commandes ]) => {
                commit('setCount', count)
                commit('setCommandes', commandes)
                resolve(commandes)
            })
        })
    },

    getNext({ commit, state, rootState }) {

        let params = {
            client_id: rootState.clients.currentId,
            site_id: rootState.sites.currentId,
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(commandes => {
                commit('setNextCommandes', commandes)
            })
    }    
}